module.exports = __webpack_public_path__ + "js/0.3d185f20.worker.js"